<template>
  <q-infinite-scroll
    :style="{
      height: listHeight,
      width: '100%',
      padding: '0 16px',
    }"
    id="overlay-dates-list"
    ref="overlay-dates-list"
    @load="getNextData"
    v-if="!loading"
  >
    <q-list>
      <template v-for="(expansionItem, index) of dateSeparatorsLazyList">
        <q-expansion-item
          class="expansion-overlay q-pt-lg"
          dense
          dense-toggle
          default-opened
          switch-toggle-side
          expand-icon="expand_less"
          :key="`${index}`"
          @after-hide="$refs['overlay-dates-list'].poll()"
        >
          <template #header>
            <div class="full-width row items-center justify-center">
              <div class="label q-mr-auto" v-if="!rowsOverline.length">
                {{ expansionItem.label }}
              </div>
              <template v-else>
                <div
                  :class="[
                    'label',
                    { 'q-ml-auto secondary q-pt-xs': index },
                    { 'q-mr-auto': !index },
                  ]"
                  v-for="(item, index) in [
                    expansionItem.label,
                    ...rowsOverline,
                  ]"
                  :key="index"
                >
                  {{ item }}
                </div>
              </template>
            </div>
          </template>

          <q-separator />

          <div :set="(values = getValues(expansionItem.label))">
            <template v-for="(value, valueIndex) of values">
              <q-item
                v-bind="{
                  class: 'row-item relative-position',
                  dense: true,
                  clickable: true,
                  'v-ripple': true,
                }"
                v-on="{
                  click: () => {
                    $emit('date-selected', value.onClickData);
                  },
                }"
                :key="`${index}-${valueIndex}`"
              >
                <div class="col-12 column items-start justify-start">
                  <div class="full-width row items-start justify-start top">
                    <div class="row items-start">
                      <q-icon
                        class="q-pr-sm q-pt-xs"
                        size="16px"
                        color="secondary"
                        :name="rowsIcon"
                        v-if="rowsIcon"
                      />
                    </div>

                    <div class="col row items-start justify-between no-wrap">
                      <div class="column justify-center items-start">
                        <div class="text-grey-9 row-text q-pl-xs full-width">
                          {{ value.tripDate }}
                        </div>
                        <div class="text-grey-8 row-caption q-pl-xs full-width">
                          {{ value.ship }}
                        </div>
                      </div>

                      <div
                        class="col column justify-center items-end text-right"
                      >
                        <template
                          v-for="(
                            displayValue, indexDisplay
                          ) in valuesToDisplay"
                        >
                          <div
                            :key="`${index}-${valueIndex}-${indexDisplay}`"
                            v-if="value[displayValue.key]"
                          >
                            <div
                              :class="[
                                'text-grey-9 row-text value q-pl-xs full-width',
                                { children: indexDisplay },
                              ]"
                            >
                              {{ currency.symbol }}
                              {{
                                Intl.NumberFormat("en-US").format(
                                  value[displayValue.key]
                                )
                              }}
                            </div>
                            <div
                              class="text-grey-8 row-caption price-caption q-pl-xs full-width"
                            >
                              {{
                                getCaption(
                                  value,
                                  displayValue.key,
                                  displayValue.caption
                                )
                              }}
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>

                  <div
                    class="row items-center justify-start bottom bg-grey-2"
                    v-if="value.promos && value.promos.length"
                  >
                    <template v-for="(promo, pIndex) in value.promos">
                      <DOverlayDatesListImage
                        :url="promo.url"
                        :imageTooltip="promo.title"
                        :key="`promo-${index}-${valueIndex}-${pIndex}`"
                      />
                    </template>
                  </div>
                </div>
              </q-item>
              <q-separator
                :key="`separator-${index}-${valueIndex}`"
                v-if="valueIndex !== values.length - 1"
              />
            </template>
          </div>
        </q-expansion-item>

        <q-separator :key="`separator-${index}`" />
      </template>
    </q-list>
  </q-infinite-scroll>

  <div
    class="full-width column items-center justify-center"
    :style="{ height: listHeight }"
    v-else
  >
    <q-spinner-dots color="secondary" size="lg" />
  </div>
</template>
<script>
import axios from "axios";
import DOverlayDatesListImage from "./DOverlayDatesListImage.vue";

export default {
  components: { DOverlayDatesListImage },
  name: "DOverlayDatesListAsync",
  props: {
    listHeight: {
      type: String,
      required: true,
    },
    hashId: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    currency: {
      type: Object,
      required: false,
      default: () => ({ name: "USD", symbol: "$" }),
    },
    apiBaseUrl: {
      type: Object,
      required: true,
      default: () => {},
    },
    noPrices: {
      type: Boolean,
      default: false,
    },
    cid: {
      type: String,
      required: true,
    },
    "company-source": {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      list: [],
      dateSeparators: [],
      dateSeparatorsLazyList: [],
      months: [
        "JANUARY",
        "FEBRUARY",
        "MARCH",
        "APRIL",
        "MAY",
        "JUNE",
        "JULY",
        "AUGUST",
        "SEPTEMBER",
        "OCTOBER",
        "NOVEMBER",
        "DECEMBER",
      ],
      monthsShort: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    };
  },
  computed: {
    rowsOverline: {
      get() {
        if (!this.data.rowsOverline) {
          return [];
        }

        return this.data.rowsOverline.split("||");
      },
    },
    valuesToDisplay: {
      get() {
        if (this.noPrices || !this.data.valuesToDisplay) {
          return [];
        }

        return this.data.valuesToDisplay.split("||").map((t) => {
          const temp = t.split(";");
          const key = temp.find((v) => v.includes("key:"));
          const caption = temp.find((v) => v.includes("caption:"));
          return {
            key: key.replace(/key:/gi, "").trim(),
            caption: caption?.replace(/caption:/gi, "").trim(),
          };
        });
      },
    },
    rowsIcon: {
      get() {
        return this.data.rowsIcon;
      },
    },
    filtersApplied: {
      get() {
        return this.data.filtersApplied ?? "[]";
      },
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;
      let response;

      if (!this.noPrices) {
        response = await axios.post(
          `${this.apiBaseUrl.src}/sailings/cruise/lowestPrices`,
          {
            cruiseHashId: [this.hashId],
            filtersApplied: this.filtersApplied,
            cid: this.cid,
          },
          {
            headers: {
              Authorization: `Bearer ${this.apiBaseUrl.params.token}`,
            },
            params: {
              "company-source": this.companySource,
            },
          }
        );
      } else {
        response = await axios.post(
          `${this.apiBaseUrl.src}/sailings/cruise/getSailingsDatesByCruise`,
          {
            cruiseHashId: [this.hashId],
          },
          {
            headers: {
              Authorization: `Bearer ${this.apiBaseUrl.params.token}`,
            },
            params: {
              "company-source": this.companySource,
            },
          }
        );
      }

      if (response.data?.length) {
        this.processData(response.data);
      }

      await new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, 500);
      });

      this.dateSeparatorsLazyList = [this.dateSeparators[0]];
      this.loading = false;
    },
    processData(data) {
      const temp = data.map((d) => {
        const departure_date = d.departure_date.split("T")[0].split("-");
        const departureDate = new Date(
          `${departure_date[0]} ${departure_date[1]} ${departure_date[2]}`
        );
        const return_date = d.return_date.split("T")[0].split("-");
        const arrivalDate = new Date(
          `${return_date[0]} ${return_date[1]} ${return_date[2]}`
        );
        const departure = `${this.days[departureDate.getDay()]}, ${
          this.monthsShort[departureDate.getMonth()]
        } ${departureDate.getDate().toString().padStart(2, "0")}`;
        const arrival = `${this.days[arrivalDate.getDay()]}, ${
          this.monthsShort[arrivalDate.getMonth()]
        } ${arrivalDate.getDate().toString().padStart(2, "0")}`;

        const promos = d.promos?.map((p) => ({ ...p, loaded: !p.url })) ?? [];

        return {
          label: `${
            this.months[departureDate.getMonth()]
          } ${departureDate.getFullYear()}`,
          tripDate: `${departure} - ${arrival}`,
          ship: d.ship_name,
          pricesLabels: d.labels?.split("||").map((i) => ({
            key: i.split("=")[0].trim(),
            value: i.split("=")[1].trim(),
          })),
          promos,
          price: d.price,
          onClickData: {
            shipId: d.ship_id,
            departureDate: d.departure_date,
          },
        };
      });

      this.dateSeparators = [...new Set(temp.map((t) => t.label))].map(
        (label) => ({ label, show: false })
      );
      this.list = temp;
    },
    getValues(label) {
      return this.list.filter((l) => l.label === label);
    },
    getCaption(item, key, caption) {
      if (caption) {
        return caption;
      }

      if (item.pricesLabels) {
        const label = item.pricesLabels.find((l) => l.key === key);

        return label.value ?? "";
      }

      return "";
    },
    getNextData(index, done) {
      if (index >= this.dateSeparators.length) {
        this.$refs["overlay-dates-list"].stop();
        done();
        return;
      }

      if (this.dateSeparatorsLazyList.length === this.dateSeparators.length) {
        this.$refs["overlay-dates-list"].stop();
        done();
        return;
      }

      if (
        this.dateSeparatorsLazyList.some(
          (d) => d.label === this.dateSeparators[index].label
        )
      ) {
        done();
        return;
      }

      this.dateSeparatorsLazyList.push(this.dateSeparators[index]);
      done();
    },
  },
};
</script>
<style lang="scss" scoped>
.top {
  margin-bottom: 6px;
}

.bottom {
  width: 100%;
  padding: 16px 6px 16px 24px;
  gap: 12px;
}
</style>
